<!--
 * @Author: ZWS
 * @Date: 2021-06-29 15:35:11
 * @LastEditTime: 2021-07-12 18:32:19
 * @Description: 增加修改模态框组件
-->
<template>
  <div class="listBox4" id="dd">
    <div class="apply1 content1" style="overflow-y: auto; margin: 0 auto">
    <Row>
      <Col span="24"><i style="margin-right: 1vh" class="iconfont icon-yuanshujumianban">
        </i>元数据信息</Col>
    </Row>
    <Divider />
    <Row type="flex" align="middle">
      <Col span="3"> 元数据名称: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.metaDataBaseName"
        />
      </Col>
      <Col span="3"> 发布日期: </Col>
      <Col span="5">
        <DatePicker
          v-model="data.publishDate"
          readonly
          disabled
          type="date"
          style="width: 100%"
          format="yyyy-MM-dd"
        ></DatePicker>
      </Col>
      <Col span="3"> 摘要: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.remark"
        />
      </Col>
    </Row>
    <Row type="flex" align="middle">
      <Col span="3"> 关键字: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.keyWord"
        />
      </Col>
      <Col span="3"> 标识符: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.naturalIdentified"
        />
      </Col>
      <Col span="3">在线资源:</Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.naturalKeyWord"
        />
      </Col>
    </Row>
    <Row>
      <Col span="24"
        ><i
          style="margin-right: 1vh"
          class="iconfont icon-ziyuantigongqingkuang"
        ></i
        >资源提供方</Col
      >
    </Row>
    <Divider />
    <Row type="flex" align="middle">
      <Col span="3">提供单位:</Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.company"
        />
      </Col>
      <Col span="3">单位地址:</Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.companyAddress"
        />
      </Col>
    </Row>
    <Row>
      <Col span="24"
        ><i
          style="margin-right: 1vh"
          class="iconfont icon-leimupinleifenleileibie"
        ></i
        >资源分类</Col>
    </Row>
    <Divider />
    <Row type="flex" align="middle">
      <Col span="3"> 分类方式: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.classifyType"
        />
      </Col>
      <Col span="3"> 类目名称: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.classifyName"
        />
      </Col>
      <Col span="3"> 类目编码: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.classifyCode"
        />
      </Col>
    </Row>
    <Row>
      <Col span="24"
        ><i style="margin-right: 1vh" class="iconfont icon-fuwu2"></i
        >服务信息</Col
      >
    </Row>
    <Divider />
    <Row type="flex" align="middle">
      <Col span="3"> 服务地址: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.serviceAddr"
        />
      </Col>
      <Col span="3"> 服务类型: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.serviceType"
        />
      </Col>
    </Row>
    <Row>
      <Col span="24"
        ><i style="margin-right: 1vh" class="iconfont icon-weihu"></i
        >元数据维护方</Col
      >
    </Row>
    <Divider />
    <Row type="flex" align="middle">
      <Col span="3"> 联系单位: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.contactCompany"
        />
      </Col>
      <Col span="3">维护方地址:</Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.defendAddr"
        />
      </Col>
    </Row>
    <Row>
      <Col span="24"
        ><i style="margin-right: 1vh" class="iconfont icon-kongjian"></i
        >空间参考信息</Col
      >
    </Row>
    <Divider />
    <Row type="flex" align="middle">
      <Col span="3"> 最小X坐标: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.minX"
        />
      </Col>
      <Col span="3"> 最小Y坐标: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.minY"
        />
      </Col>
      <Col span="3"> 最大X坐标: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.maxX"
        />
      </Col>
    </Row>
    <Row type="flex" align="middle">
      <Col span="3"> 最大Y坐标: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.maxY"
        />
      </Col>
      <Col span="3"> 空间坐标系: </Col>
      <Col span="5">
        <i-input
          class="text_area ysjinpt"
          placeholder="请输入"
          readonly
          disabled
          v-model="data.wcs"
        />
      </Col>
    </Row>
  </div>
  </div>
</template>

<script>
export default {
  name: "MetadataModal",
  props: {
    itemData: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
    };
  },
  computed:{
    data() {
      return JSON.parse(JSON.stringify(this.itemData));
    }
  },
};
</script>

<style lang="less" scoped>
.iconfont {
  color: #0099fa;
}
.listBox4 {
  overflow: auto; 
  width: 100%; 
  margin: 0 auto;
  padding: 0 10px;
  .content1{
    border: 1px solid #cccccc;
    border-radius: 3px;
    padding: 1.6rem;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  .ivu-row-flex {
    padding: 0.6rem 0;
  }
  .ivu-col-span-24 {
    font-weight: 600;
    font-size: 1.4rem;
  }
  .ivu-col-span-4,
  .ivu-col-span-3 {
    text-align: right;
    padding-right: 0.4rem;
    line-height: 3.2rem;
    height: 3.2rem;
  }
}
.ivu-divider-horizontal{
  margin: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/layers/metadataModal.vue